module.exports = __webpack_public_path__ + "img/bt-flower-002.8e672e8.webp";